import {loginRequest} from "../authConfig";
import * as App from "../index";
import {SignedOutRequestStatus} from "./Constants";
import {BrowserAuthError, BrowserAuthErrorCodes, InteractionRequiredAuthError, SilentRequest} from "@azure/msal-browser";
import {storageMng} from "./StorageMng";

type AuthorizedRequestConfig = {
    headers: { [key: string]: unknown };
};

async function addAuthorizedHeader<T extends AuthorizedRequestConfig>(config: T, handleInteraction: boolean): Promise<T> {
    const instance = App.msalInstance;
    const accounts = instance.getAllAccounts();

    if (!accounts[0]) return Promise.reject(SignedOutRequestStatus);

    const accessTokenRequest = { account: accounts[0] } as SilentRequest;

    return instance
        .acquireTokenSilent(accessTokenRequest)
        .then((accessTokenResponse) => {
            const accessToken = accessTokenResponse.accessToken;
            config.headers['Authorization'] = `Bearer ${accessToken}`;
            config.headers['Content-Type'] = 'application/json';
            return Promise.resolve(config);
        })
        .catch(function (error) {
            const requiresInteractiveLogin = error instanceof InteractionRequiredAuthError
                || (error instanceof BrowserAuthError && error.errorCode === BrowserAuthErrorCodes.timedOut);

            console.log(error);

            if (!handleInteraction) return Promise.reject(error);
            if (requiresInteractiveLogin) return handleLogin().then(() => config);
            if (error instanceof BrowserAuthError && !requiresInteractiveLogin) return addAuthorizedHeader(config, false);

            return Promise.reject(error);
        });
}

 async function handleLogin() {
    const instance = App.msalInstance;
    storageMng.clearStorage();

    await instance.loginRedirect(loginRequest)
            .catch((error) => {
                console.log(error);
            });
}

 async function handleLogout() {
    const instance = App.msalInstance;
    storageMng.clearStorage();
    await instance.logoutRedirect();
}

export default { handleLogin, handleLogout, addAuthorizedHeader  };
